import firebase from 'firebase';

var firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: 'playlist-search-tool-8b406.firebaseapp.com',
  databaseURL: 'https://playlist-search-tool-8b406.firebaseio.com',
  projectId: 'playlist-search-tool-8b406',
  storageBucket: 'playlist-search-tool-8b406.appspot.com',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};
// Initialize Firebase
const fire = firebase.initializeApp(firebaseConfig);
export default fire